
// Taken from https://mika-s.github.io/javascript/colors/hsl/2017/12/05/generating-random-colors-in-javascript.html
export function generateHslaColors(saturation, lightness, alpha, count) {
  const colors = []
  const huedelta = Math.trunc(360 / count)

  for (let i = 0; i < count; i += 1) {
    const hue = i * huedelta
    colors.push(`hsla(${hue},${saturation}%,${lightness}%,${alpha})`)
  }

  return colors
}

export function generateColors(count) {
  return generateHslaColors(70, 70, 0.7, count)
}
